/**
 * Reusable form section for the per-centre lifecycle TTL / buffer fields.
 * Used by both the SettingsPage (center_admin) and the CenterModal (superadmin).
 */

export interface LifecycleFieldsProps {
  readonly pendingTtlHours: number;
  readonly setPendingTtlHours: (n: number) => void;
  readonly approvalTtlHours: number;
  readonly setApprovalTtlHours: (n: number) => void;
  readonly checkinCompletionBufferMinutes: number;
  readonly setCheckinCompletionBufferMinutes: (n: number) => void;
}

interface Row {
  readonly label: string;
  readonly value: number;
  readonly min: number;
  readonly max: number;
  readonly fallback: number;
  readonly hint: string;
  readonly set: (n: number) => void;
}

export function LifecycleFields(p: LifecycleFieldsProps) {
  const rows: Row[] = [
    {
      label: 'Plazo para que el cliente confirme (horas)',
      value: p.pendingTtlHours,
      min: 1,
      max: 720,
      fallback: 24,
      hint: 'Tras este plazo sin confirmar, la reserva pendiente se cancela. 1–720.',
      set: p.setPendingTtlHours,
    },
    {
      label: 'Plazo para aprobar (modo manual, horas)',
      value: p.approvalTtlHours,
      min: 1,
      max: 720,
      fallback: 72,
      hint: 'Plazo del centro para aprobar/rechazar antes de cancelar. 1–720.',
      set: p.setApprovalTtlHours,
    },
    {
      label: 'Auto-completar tras la cita (minutos)',
      value: p.checkinCompletionBufferMinutes,
      min: 0,
      max: 1440,
      fallback: 0,
      hint: 'Minutos tras endTime para cerrar reservas en check-in. 0–1440.',
      set: p.setCheckinCompletionBufferMinutes,
    },
  ];
  return (
    <>
      {rows.map((r) => (
        <div className="field" key={r.label}>
          <label className="field-label">{r.label}</label>
          <input
            type="number"
            className="input"
            min={r.min}
            max={r.max}
            value={r.value}
            onChange={(e) => { r.set(parseInt(e.target.value, 10) || r.fallback); }}
          />
          <p style={{ fontSize: 11.5, color: 'var(--fg-soft)', marginTop: 4 }}>{r.hint}</p>
        </div>
      ))}
    </>
  );
}
